import { CasinoTypes } from '../../utils/CasinoTypes';

import AbstractConfigProvider from './AbstractConfigProvider';

export default class CasinoConfigProvider extends AbstractConfigProvider {
    public prefix: string = 'casino';

    public getConfig() {
        return {
            ...this.add('slug', process.env.MIX_CASINO_PAGE_SLUG),
            ...this.add('page_mode', process.env.MIX_CASINO_MODE),
            ...this.add('type', this.getCasinoType()),
        };
    }

    private getCasinoType(): CasinoTypes {
        const type = process.env.MIX_CASINO_TYPE?.toLowerCase();

        if (type && Object.values(CasinoTypes).includes(type as CasinoTypes)) {
            return type as CasinoTypes;
        }

        return CasinoTypes.normal;
    }
}
